// extracted by mini-css-extract-plugin
module.exports = {"button_box":"PdfDownloadModal__button_box--3HSkI","button_frame":"PdfDownloadModal__button_frame--1k0z-"};